/* js/components/TrackPlayer.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Youtube from './mediaPlayers/Youtube.svelte';
import Vimeo from './mediaPlayers/Vimeo.svelte';
import Soundcloud from './mediaPlayers/Soundcloud.svelte';
import BandcampTrack from './mediaPlayers/BandcampTrack.svelte';
import DailyMotion from './mediaPlayers/DailyMotion.svelte';
import Mx3 from './mediaPlayers/Mx3.svelte';
import Rts from './mediaPlayers/Rts.svelte';
import LocalMp3 from './mediaPlayers/LocalMp3.svelte';

function create_if_block_8(ctx) {
	let a;
	let t;

	return {
		c() {
			a = element("a");
			t = text(/*src*/ ctx[1]);
			attr(a, "href", /*src*/ ctx[1]);
			attr(a, "target", "_blank");
			attr(a, "rel", "nofollow noopener noreferrer");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, t);
		},
		p(ctx, dirty) {
			if (dirty & /*src*/ 2) set_data(t, /*src*/ ctx[1]);

			if (dirty & /*src*/ 2) {
				attr(a, "href", /*src*/ ctx[1]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

// (29:29) 
function create_if_block_7(ctx) {
	let localmp3;
	let current;
	localmp3 = new LocalMp3({ props: { src: /*src*/ ctx[1] } });

	return {
		c() {
			create_component(localmp3.$$.fragment);
		},
		m(target, anchor) {
			mount_component(localmp3, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const localmp3_changes = {};
			if (dirty & /*src*/ 2) localmp3_changes.src = /*src*/ ctx[1];
			localmp3.$set(localmp3_changes);
		},
		i(local) {
			if (current) return;
			transition_in(localmp3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(localmp3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(localmp3, detaching);
		}
	};
}

// (27:24) 
function create_if_block_6(ctx) {
	let rts;
	let current;
	rts = new Rts({ props: { src: /*src*/ ctx[1] } });

	return {
		c() {
			create_component(rts.$$.fragment);
		},
		m(target, anchor) {
			mount_component(rts, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const rts_changes = {};
			if (dirty & /*src*/ 2) rts_changes.src = /*src*/ ctx[1];
			rts.$set(rts_changes);
		},
		i(local) {
			if (current) return;
			transition_in(rts.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(rts.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(rts, detaching);
		}
	};
}

// (25:24) 
function create_if_block_5(ctx) {
	let mx3;
	let current;
	mx3 = new Mx3({ props: { src: /*src*/ ctx[1] } });

	return {
		c() {
			create_component(mx3.$$.fragment);
		},
		m(target, anchor) {
			mount_component(mx3, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const mx3_changes = {};
			if (dirty & /*src*/ 2) mx3_changes.src = /*src*/ ctx[1];
			mx3.$set(mx3_changes);
		},
		i(local) {
			if (current) return;
			transition_in(mx3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(mx3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(mx3, detaching);
		}
	};
}

// (23:29) 
function create_if_block_4(ctx) {
	let bandcamptrack;
	let current;
	bandcamptrack = new BandcampTrack({ props: { trackId: /*src*/ ctx[1] } });

	return {
		c() {
			create_component(bandcamptrack.$$.fragment);
		},
		m(target, anchor) {
			mount_component(bandcamptrack, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const bandcamptrack_changes = {};
			if (dirty & /*src*/ 2) bandcamptrack_changes.trackId = /*src*/ ctx[1];
			bandcamptrack.$set(bandcamptrack_changes);
		},
		i(local) {
			if (current) return;
			transition_in(bandcamptrack.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(bandcamptrack.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(bandcamptrack, detaching);
		}
	};
}

// (21:32) 
function create_if_block_3(ctx) {
	let dailymotion;
	let current;
	dailymotion = new DailyMotion({ props: { videoUrl: /*src*/ ctx[1] } });

	return {
		c() {
			create_component(dailymotion.$$.fragment);
		},
		m(target, anchor) {
			mount_component(dailymotion, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const dailymotion_changes = {};
			if (dirty & /*src*/ 2) dailymotion_changes.videoUrl = /*src*/ ctx[1];
			dailymotion.$set(dailymotion_changes);
		},
		i(local) {
			if (current) return;
			transition_in(dailymotion.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(dailymotion.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(dailymotion, detaching);
		}
	};
}

// (19:31) 
function create_if_block_2(ctx) {
	let soundcloud;
	let current;
	soundcloud = new Soundcloud({ props: { clipUrl: /*src*/ ctx[1] } });

	return {
		c() {
			create_component(soundcloud.$$.fragment);
		},
		m(target, anchor) {
			mount_component(soundcloud, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const soundcloud_changes = {};
			if (dirty & /*src*/ 2) soundcloud_changes.clipUrl = /*src*/ ctx[1];
			soundcloud.$set(soundcloud_changes);
		},
		i(local) {
			if (current) return;
			transition_in(soundcloud.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(soundcloud.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(soundcloud, detaching);
		}
	};
}

// (17:26) 
function create_if_block_1(ctx) {
	let vimeo;
	let current;
	vimeo = new Vimeo({ props: { src: /*src*/ ctx[1] } });

	return {
		c() {
			create_component(vimeo.$$.fragment);
		},
		m(target, anchor) {
			mount_component(vimeo, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const vimeo_changes = {};
			if (dirty & /*src*/ 2) vimeo_changes.src = /*src*/ ctx[1];
			vimeo.$set(vimeo_changes);
		},
		i(local) {
			if (current) return;
			transition_in(vimeo.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(vimeo.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(vimeo, detaching);
		}
	};
}

// (15:0) {#if type == "youtube"}
function create_if_block(ctx) {
	let youtube;
	let current;
	youtube = new Youtube({ props: { src: /*src*/ ctx[1] } });

	return {
		c() {
			create_component(youtube.$$.fragment);
		},
		m(target, anchor) {
			mount_component(youtube, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const youtube_changes = {};
			if (dirty & /*src*/ 2) youtube_changes.src = /*src*/ ctx[1];
			youtube.$set(youtube_changes);
		},
		i(local) {
			if (current) return;
			transition_in(youtube.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(youtube.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(youtube, detaching);
		}
	};
}

function create_fragment(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;

	const if_block_creators = [
		create_if_block,
		create_if_block_1,
		create_if_block_2,
		create_if_block_3,
		create_if_block_4,
		create_if_block_5,
		create_if_block_6,
		create_if_block_7,
		create_if_block_8
	];

	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*type*/ ctx[0] == "youtube") return 0;
		if (/*type*/ ctx[0] == "vimeo") return 1;
		if (/*type*/ ctx[0] == "soundcloud") return 2;
		if (/*type*/ ctx[0] == "dailymotion") return 3;
		if (/*type*/ ctx[0] == "bandcamp") return 4;
		if (/*type*/ ctx[0] == "mx3") return 5;
		if (/*type*/ ctx[0] == "rts") return 6;
		if (/*type*/ ctx[0] == "localmp3") return 7;
		if (/*type*/ ctx[0] == "link") return 8;
		return -1;
	}

	if (~(current_block_type_index = select_block_type(ctx, -1))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				} else {
					if_block = null;
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { type } = $$props;
	let { src } = $$props;

	$$self.$$set = $$props => {
		if ('type' in $$props) $$invalidate(0, type = $$props.type);
		if ('src' in $$props) $$invalidate(1, src = $$props.src);
	};

	return [type, src];
}

class TrackPlayer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { type: 0, src: 1 });
	}
}

export default TrackPlayer;